import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/nextjs-asktraining.com.sg/nextjs-asktraining.com.sg/src/app/generative-ai-courses/sections/CourseBannerForm.tsx");
